import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';

import FullModalBlank from 'components/FullModalBlank';
import { ArrowBack, ArrowNext } from 'components/SvgIcons';

import './CarouselFullModalStyles.scss';

const propTypes = {
    //FullModal parameters
    isOpen: PropTypes.bool,
    modalClassName: PropTypes.string,
    modalOverlayClassName: PropTypes.string,
    headerClass: PropTypes.string,
    contentClass: PropTypes.string,
    contentLeftClass: PropTypes.string,
    contentCenterClass: PropTypes.string,
    contentRightClass: PropTypes.string,
    onAfterOpen: PropTypes.func,
    onRequestClose: PropTypes.func,
    withCloseIcon: PropTypes.bool,
    shouldCloseOnEsc: PropTypes.bool,
    shouldCloseOnOverlayClick: PropTypes.bool,
    contentLeft: PropTypes.func,
    contentCenter: PropTypes.func,
    contentRight: PropTypes.func,
    //Carousel parameters
    arrows: PropTypes.bool,
    dots: PropTypes.bool,
    lazyLoad: PropTypes.string,
    infinite: PropTypes.bool,
    speed: PropTypes.number,
    slidesToShow: PropTypes.number,
    slidesToScroll: PropTypes.number,
    draggable: PropTypes.bool,
    centerMode: PropTypes.bool,
    initialSlide: PropTypes.number,
    accessibility: PropTypes.bool,
    //Images
    images: PropTypes.array,
    imageSelected: PropTypes.object,
    updateImageSelected: PropTypes.func,
};

class CarouselFullModal extends PureComponent {
    state = {};

    getInitialSlide = () => {
        const { images, imageSelected } = this.props;

        if (images.length === 0 || !imageSelected) return;

        let initialSlide;
        for (let i = 0; i < images.length; i++) {
            if (imageSelected.Id === images[i].Id) {
                initialSlide = i;
                break;
            }
        }

        return initialSlide;
    };

    onClickPrevious = () => {
        this.slider.slickPrev();
    };

    onClickNext = () => {
        this.slider.slickNext();
    };

    renderImages = () => {
        const { images } = this.props;

        if (!images) return null;

        const imagesToSlide = images.map((image, index) => {
            return (
                <div key={index} className="fm-carousel-full-modal__slider-image">
                    <img src={image.url} />
                </div>
            );
        });

        return imagesToSlide;
    };

    render() {
        const {
            //FullModal parameters
            isOpen,
            modalClassName,
            modalOverlayClassName,
            headerClass,
            contentClass,
            contentLeftClass,
            contentCenterClass,
            contentRightClass,
            onAfterOpen,
            onRequestClose,
            withCloseIcon,
            shouldCloseOnEsc,
            shouldCloseOnOverlayClick,
            contentLeft,
            contentCenter,
            contentRight,
            //Carousel parameters
            arrows = false,
            dots = false, //navigation dots
            lazyLoad = 'ondemand', // 'ondemand' is the other option
            infinite = true,
            speed = 500,
            slidesToShow = 1,
            slidesToScroll = 1,
            draggable = false, //leave it false cause it causes wierd behaviour
            centerMode = false, //center current slide
            initialSlide,
            accessibility = true,
            //Images
            imageSelected,
            images,
            updateImageSelected,
        } = this.props;

        if (images.length === 0 || !imageSelected || !updateImageSelected) return null;

        let headerClassName = ['fm-carousel-full-modal__header'];
        if (headerClass) headerClassName.push(headerClass);

        let contentLeftClassName = ['fm-carousel-full-modal__header-left'];
        if (contentLeftClass) contentLeftClassName.push(contentLeftClass);

        let contentCenterClassName = ['fm-carousel-full-modal__header-center'];
        if (contentCenterClass) contentCenterClassName.push(contentCenterClass);

        let contentRightClassName = ['fm-carousel-full-modal__header-right'];
        if (contentRightClass) contentRightClassName.push(contentRightClass);

        let contentClassName = ['fm-carousel-full-modal__content'];
        if (contentClass) contentClassName.push(contentClass);

        let slideToStart = 0;
        if (!initialSlide) slideToStart = this.getInitialSlide();
        else slideToStart = initialSlide;

        const settings = {
            className: 'fm-carousel-full-modal__slider',
            arrows: arrows,
            dots: dots,
            lazyLoad: lazyLoad,
            infinite: infinite,
            speed: speed,
            slidesToShow: slidesToShow,
            slidesToScroll: slidesToScroll,
            centerMode: centerMode,
            draggable: draggable,
            initialSlide: slideToStart,
            accessibility: accessibility,
            beforeChange: (current, next) => {
                updateImageSelected(images[next]);
            },
        };

        return (
            <FullModalBlank
                className={modalClassName}
                overlayClassName={modalOverlayClassName}
                headerClass={headerClassName}
                isOpen={isOpen}
                onAfterOpen={onAfterOpen}
                withCloseIcon={withCloseIcon}
                onRequestClose={onRequestClose}
                shoudCloseOnEsc={shouldCloseOnEsc}
                shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
                contentLeftClassName={contentLeftClassName}
                contentCenterClassName={contentCenterClassName}
                contentRightClassName={contentRightClassName}
                contentLeft={contentLeft}
                contentCenter={contentCenter}
                contentRight={contentRight}
            >
                <div className="fm-carousel-full-modal_content-background" />
                <div className={contentClassName.join(' ')}>
                    <Slider ref={(c) => (this.slider = c)} {...settings}>
                        {this.renderImages()}
                    </Slider>
                    <div
                        className="fm-carousel-full-modal__previous-button"
                        onClick={this.onClickPrevious}
                    >
                        <div className="previous-button-content">
                            <ArrowBack color="$fmWhite" />
                        </div>
                    </div>
                    <div
                        className="fm-carousel-full-modal__next-button with-background"
                        onClick={this.onClickNext}
                    >
                        <div className="next-button-content">
                            <ArrowNext color="$fmWhite" />
                        </div>
                    </div>
                </div>
            </FullModalBlank>
        );
    }
}

CarouselFullModal.propTypes = propTypes;

export default CarouselFullModal;
